.harmonisedDependency {
	border-radius: 50%;
	background-color: var(--ds-background-neutral-bold, var(--adg3-color-N100));
	color: var(--ds-text-inverse, var(--adg3-color-N0));
	height: 14px;
	width: 14px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 10px;
	margin: 5px;
}

.harmonisedDependencyWithWarning {
	background-color: var(--ds-background-danger, var(--adg3-color-R50));
	color: var(--ds-text-danger, var(--adg3-color-R400));
}

.dependencyLine {
	border-bottom: 2px solid;
	border-color: var(--ds-border, var(--adg3-color-N50));
	width: 12px;
	margin-left: 5px;
}

.dependencyLineWithWarning {
	border-color: var(--ds-border-danger, var(--adg3-color-R300));
}
